import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQnAContext } from './contexts/QnAContext';
import styles from './QnAWidget.module.scss';
import { QnAWidgetIcon } from './QnAWidgetIcon';
import { QnAWidgetWindow } from './QnAWidgetWindow';

const HIDDEN_PATH_PREFIXES = [
  '/tools',
  '/play/',
  '/avatar-tool',
  '/maintenancepage',
  '/create/template/',
];

export function QnAWidget() {
  const { isExpanded, toggleExpanded, headerButtonCount } = useQnAContext();
  const { pathname } = useLocation();

  if (HIDDEN_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return null;
  }

  return (
    <div className={`${styles.widgetContainer} ${isExpanded ? styles.expanded : ''}`}>
      <QnAWidgetWindow />
      {/* Pages with <PageHeaderLoged> show <QnAWidgetHeaderButton> instead */}
      {headerButtonCount === 0 && <QnAWidgetIcon onClick={toggleExpanded} />}
    </div>
  );
}

interface QnAWidgetHeaderButtonProps {
  className?: string;
}

// Button only; the chat window stays in <QnAWidget>, mounted once in <App>,
// so it isn't rebuilt on navigation or re-rendered by the header's maintenance polling.
export const QnAWidgetHeaderButton = React.memo(function QnAWidgetHeaderButton({
  className = '',
}: QnAWidgetHeaderButtonProps) {
  const { isExpanded, toggleExpanded, registerHeaderButton } = useQnAContext();

  useEffect(() => registerHeaderButton(), [registerHeaderButton]);

  return (
    <div className={`${styles.headerButton} ${isExpanded ? styles.expanded : ''} ${className}`}>
      <QnAWidgetIcon onClick={toggleExpanded} />
    </div>
  );
});
